import Api from "../../utils/axios";

export const RegionMasterApi = {
  createRegion: (payload) =>
    Api.post("/master/create-delivery-region", payload),
  updateRegion: (payload, id) =>
    Api.put(`/master/update-delivery-region/${id}`, payload),
  getRegionById: (id) => Api.get(`/master/get-delivery-region-by-id/${id}`),
  getAllRegion: (payload, search = "") =>
    Api.post(`/master/get-all-delivery-regions?search=${search}`, payload),
  getAllRegionData: (id) =>
    Api.get(`/master/get-all-delivery-regions-without-pagination`),
  // deleteRegion: (id) => Api.delete(`/advertise/delete-Region/${id}`)
  importDeliveryRegion: (payload) =>
    Api.post(`master/delivery-region-import`, payload),
};
